import { getCookie } from "./jwt/_helpers/cookie";
import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import LanguageDetector from "i18next-browser-languagedetector";

import translationEN from "./locales/en/translation";
import translationDE from "./locales/de/translation";
import translationIT from "./locales/it/translation";
import translationES from "./locales/es/translation";
import translationFR from "./locales/fr/translation";
import translationHR from "./locales/hr/translation";
import translationNL from "./locales/nl/translation";
import translationPT from "./locales/pt/translation";

const resources = {
  en: { translation: translationEN },
  de: { translation: translationDE },
  it: { translation: translationIT },
  es: { translation: translationES },
  fr: { translation: translationFR },
  hr: { translation: translationHR },
  nl: { translation: translationNL },
  pt: { translation: translationPT },
};

const language = getCookie("language");

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources: resources,
    lng: language,
    fallbackLng: "en",
    detection: {
      order: ["querystring", "cookie", "localStorage", "navigator", "htmlTag"],
      caches: ["localStorage", "cookie"]
    },
    interpolation: {
      escapeValue: false
    }
  });

export default i18n;